import { render, staticRenderFns } from "./ModalAdBlockDetect.vue?vue&type=template&id=58ef0a20&scoped=true&"
import script from "./ModalAdBlockDetect.vue?vue&type=script&lang=js&"
export * from "./ModalAdBlockDetect.vue?vue&type=script&lang=js&"
import style0 from "./ModalAdBlockDetect.vue?vue&type=style&index=0&id=58ef0a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ef0a20",
  null
  
)

export default component.exports